import { H2RInput } from "../../imports";
import { H2RSelect } from "../../imports";
import { celebrationDefinitions } from "../../imports";

export const GraphicEditor = ({ cue, onUpdate }) => {
	return (
		<>
			<H2RSelect
				selected={cue.celebrationType || "none"}
				label="Celebration"
				options={[
					{
						label: "Balloons",
						value: "balloons",
					},
					{
						label: "Confetti",
						value: "confetti",
					},
					{
						label: "Money",
						value: "money",
					},
					{
						label: "Emoji",
						value: "emoji",
					},
				]}
				onChange={(value) => {
					return onUpdate({ celebrationType: value });
				}}
			/>

			{cue.celebrationType === "emoji" && (
				<H2RInput
					label="Emoji"
					value={cue.emoji}
					placeholder="🚀"
					onChange={(value) => {
						onUpdate({ emoji: value });
					}}
				/>
			)}
		</>
	);
};

export const GraphicCueContent = ({ cue, twoLines }) => {
	return (
		<div
			className={`overflow-ellipsis w-48 md:w-auto max-w-xs md:max-w-sm lg:max-w-lg overflow-hidden
            ${twoLines ? "whitespace-normal max-h-10" : "whitespace-nowrap"}
            `}
		>
			<span className="font-semibold">
				{celebrationDefinitions?.[cue.celebrationType]?.name}{" "}
				{cue.celebrationType === "emoji" && cue.emoji}
			</span>
		</div>
	);
};
